export const LOAN_CONDITIONS_INFO_TABLE_COLUMN_ID = {
  TYPE: 'type',
  SLA: 'sla',
  POTENTIAL_SIGNERS: 'potentialSignersFullNames',
  ACTUAL_SIGNERS: 'actualSignersFullNames',
  SLA_TYPE: 'slaType',
  ELIGIBLE_FOR_SIGN_OFF_DATE: 'eligibleForSignOffDate',
};

export const columns = [
  {
    id: LOAN_CONDITIONS_INFO_TABLE_COLUMN_ID.TYPE,
    align: 'left',
    label: 'SLA Level',
    className: 'w-1/6',
  },
  {
    id: LOAN_CONDITIONS_INFO_TABLE_COLUMN_ID.SLA,
    align: 'left',
    label: 'SLA',
    className: 'w-1/6',
  },
  {
    id: LOAN_CONDITIONS_INFO_TABLE_COLUMN_ID.POTENTIAL_SIGNERS,
    align: 'left',
    label: 'Potential Users',
    className: 'break-words',
  },
  {
    id: LOAN_CONDITIONS_INFO_TABLE_COLUMN_ID.ACTUAL_SIGNERS,
    align: 'left',
    label: 'Users to complete',
    className: 'break-words',
  },
  {
    id: LOAN_CONDITIONS_INFO_TABLE_COLUMN_ID.SLA_TYPE,
    align: 'left',
    label: 'Type',
    className: 'w-1/6',
  },
  {
    id: LOAN_CONDITIONS_INFO_TABLE_COLUMN_ID.ELIGIBLE_FOR_SIGN_OFF_DATE,
    align: 'left',
    label: 'SLA Start Date/Time',
    className: 'w-1/6',
  },
];
